<div [style.width]="width">
  <mat-label class="font-semibold" *ngIf="label">
    {{ label | translate }}
    <small class="text-gray-400">({{ 'shared:required' | translate }})</small>
  </mat-label>

  <input-search
    class="lt-md:mb-2 w-full"
    [disableAnimation]="true"
    [createParams]="false"
    [width]="100"
    placeholder="createWithdrawMoney:placeholderSearch"
    (valueChange)="filterBankAccounts($event)"
    *ngIf="version == 2"></input-search>

  <div
    aria-live="polite"
    *ngIf="!loadingBankAccounts && !bankAccounts.length && version == 1">
    {{ 'createWithdrawMoney:missingVerifiedProviders' | translate }}
    <a [routerLink]="['/providers']" (click)="closeDialog()">
      <span class="link">
        {{ 'createWithdrawMoney:missingVerifiedProvidersAction' | translate }}
      </span>
    </a>
  </div>

  <div
    aria-live="polite"
    *ngIf="!loadingBankAccounts && !bankAccountsBk.length && version == 2">
    {{ 'createWithdrawMoney:missingVerifiedProviders' | translate }}
    <a [routerLink]="['/providers']" (click)="closeDialog()">
      <span class="link">
        {{ 'createWithdrawMoney:missingVerifiedProvidersAction' | translate }}
      </span>
    </a>
  </div>

  <div
    aria-live="polite"
    *ngIf="
      !loadingBankAccounts &&
      bankAccountsBk.length &&
      !bankAccounts.length &&
      version == 2
    ">
    {{ 'createWithdrawMoney:missingVerifiedProviders2' | translate }}
  </div>

  <mat-selection-list
    class="v{{ version }}"
    [multiple]="false"
    [(ngModel)]="value"
    (ngModelChange)="valueChanged.next(value?.[0])"
    *ngIf="!loadingBankAccounts && bankAccounts.length > 0">
    <mat-list-option
      *ngFor="let item of bankAccounts"
      [value]="item"
      [class.shadow-md]="version == 1"
      class="py-{{ version == 1 ? '5' : '2' }}">
      <div class="option-container" *ngIf="version == 1">
        <div [style.flexBasis]="'20%'" class="item">
          <div
            class="flex flex-col relative rounded-full w-10 h-10 min-w-10 bg-gray-200 justify-center items-center gt-xs:mr-4 mr-2">
            <img
              class="w-10 rounded-full object-cover h-full"
              [src]="
                'https://flagcdn.com/' +
                (item.currency | currencyCountry) +
                '.svg'
              "
              alt="item.country"
              fill />
          </div>
        </div>
        <div [style.flexBasis]="'55%'" class="item">
          <div class="child">
            <h3>{{ item.alias }}</h3>
          </div>
          <div class="child">
            <span class="font-light">{{
              item.accountNumber | maskAccountNumber
            }}</span>
          </div>
        </div>
        <div [style.flexBasis]="'25%'" class="item">
          <div class="child">
            <h3>
              {{ item.currency }}
              {{ 'currencyName:' + item.currency | translate }}
            </h3>
          </div>
          <div class="child">
            <span class="font-light">{{
              'country:' + item.country.toUpperCase() | translate
            }}</span>
          </div>
        </div>
      </div>

      <div class="flex justify-between items-center" *ngIf="version == 2">
        <div class="flex items-center w-1/2 gap-3">
          <img
            class="w-10 h-10 rounded-full object-cover"
            [src]="
              'https://flagcdn.com/' +
              (item.currency | currencyCountry) +
              '.svg'
            "
            alt="item.country"
            fill />
          <div class="text-left">
            <div
              class="font-semibold truncate"
              style="max-width: calc(460px - 30px)">
              {{ item.alias }}
            </div>
            <div class="text-gray-400 text-sm truncate">
              {{ item.currency }}
              {{ 'currencyName:' + item.currency | translate }}
              <!-- {{ item.payee.name }}, {{ item.payee.city }},
              {{ 'country:' + item.payee.country.toUpperCase() | translate }} -->
            </div>
          </div>
        </div>

        <div class="text-right w-1/2">
          <div class="text-gray-400">
            {{ item.accountNumber | maskAccountNumber }}
          </div>
          <div class="text-sm truncate">
            {{ item.bankName }},
            {{ 'country:' + item.country.toUpperCase() | translate }}
          </div>
        </div>
      </div>
    </mat-list-option>
  </mat-selection-list>

  <mat-progress-spinner
    class="m-auto my-5"
    [diameter]="24"
    [mode]="'indeterminate'"
    *ngIf="loadingBankAccounts"></mat-progress-spinner>
</div>
